import { handleSearchParams } from "src/utils"
import { APICall } from "."

const ControllerName = "MobWaitingPackingRequests"

export const GetWaitingForPacking = (searchParams: any, tableFiller: any, hospitalId: number) => {
    let searchData = handleSearchParams(searchParams, tableFiller)
    return APICall("get", ControllerName + `/GetWaitingPackingRequests${searchData}${hospitalId ? `&hospitalId=${hospitalId}` : ""}`)
}

export const SetRequestAsPacked = (requestIds: number[]) => {
    return APICall("post", ControllerName + `/SetRequestsAsPacked`, { requestIds })
}